import { useCustomer } from "@/modules/clients/hooks/use-customer.hook";
import { EnvironmentVariables } from "@/modules/common/types";
import { handleContactWhatsapp } from "@/modules/common/utils";

export interface OpenProposalInWhatsappProps extends BuildFileURLProps {
  customerUId: string;
}

interface BuildFileURLProps {
  trackUid: string | undefined;
  rootVersion: number;
  minorVersion: number;
}
export default function useOpenInWhatsapp({
  customerUId,
  trackUid,
  rootVersion,
  minorVersion,
}: OpenProposalInWhatsappProps) {
  const buildFileURL = (): string =>
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/tracks/${trackUid}/rental-proposal?v=${rootVersion}.${minorVersion}`;
  const { data: customer, isLoading } = useCustomer({ uid: customerUId });

  const handleWhatsapp = async () => {
    if (!customer || !trackUid) {
      throw new Error("Failed to open WhatsApp");
    }

    const telephone =
      customer.telephones.find((t) => t.default)?.telephone ??
      customer.telephones[0]?.telephone;

    if (!telephone) {
      throw new Error("Please add phone number");
    }

    const message = `Hello ${customer.name},

Here’s your financial proposal for the requested property.
Please review it at your convenience, and I’m available if you’d like to walk through it together.

${buildFileURL()}`;

    handleContactWhatsapp(telephone, message);
  };

  return { handleWhatsapp, isLoading };
}
